import { ClearSearchIcon, IconWrapper, SearchIcon } from './LargeSearch.styled';
import { searchWrapper, searchWrapperBottomBorderOnly, searchWrapperTopBorderOnly } from '../styles/legacy';
import { searchWrapper as searchWrapperCitron, searchWrapperBottomBorderOnly as searchWrapperBottomBorderOnlyCitron, searchWrapperTopBorderOnly as searchWrapperTopBorderOnlyCitron, } from '../styles/citron';
import { citrusStyled } from '@citrus/runtime';
var ClearIconButtonWrapper = citrusStyled.div('N/A', null);
var SearchWrapper = citrusStyled.div('searchWrapper', { legacy: searchWrapper, citron: searchWrapperCitron });
var SearchWrapperBottomBorderOnly = citrusStyled.div('searchWrapperBottomBorderOnly', {
    legacy: searchWrapperBottomBorderOnly,
    citrus2022: searchWrapperBottomBorderOnlyCitron,
});
var SearchWrapperTopBorderOnly = citrusStyled.div('searchWrapperTopBorderOnly', {
    legacy: searchWrapperTopBorderOnly,
    citrus2022: searchWrapperTopBorderOnlyCitron,
});
export { ClearIconButtonWrapper, ClearSearchIcon, IconWrapper, SearchIcon, SearchWrapper, SearchWrapperBottomBorderOnly, SearchWrapperTopBorderOnly, };
export var Styled = {
    ClearIconButtonWrapper: ClearIconButtonWrapper,
    ClearSearchIcon: ClearSearchIcon,
    IconWrapper: IconWrapper,
    SearchIcon: SearchIcon,
    SearchWrapper: SearchWrapper,
    SearchWrapperBottomBorderOnly: SearchWrapperBottomBorderOnly,
    SearchWrapperTopBorderOnly: SearchWrapperTopBorderOnly,
};
